// @flow
import React from "react";
import { useSelector } from "react-redux";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoBenchmark,
  SelecaoAtivoSemRisco,
  SelecaoPeriodicidade,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPeriodoComBenchmarkEAtivoSemRisco = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        ativoSemRisco: edicaoMedida.ativoSemRisco,
        benchmark: edicaoMedida.benchmark,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        ativoSemRisco: edicaoMedida.ativoSemRisco,
        benchmark: edicaoMedida.benchmark,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoComBenchmarkEAtivoSemRisco = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoAtivoSemRisco />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoBenchmark />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida">
            <SelecaoAtivoSemRisco />
          </div>

          <div className="ConfiguracaoMedida__vertical-divider" />

          <div className="ConfiguracaoMedida">
            <SelecaoBenchmark />
          </div>

          <div className="ConfiguracaoMedida__vertical-divider" />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />

        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida--flex">
            <SelecaoPeriodo exibirPeriodicidade={false} />
          </div>

          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PeriodoComBenchmarkEAtivoSemRisco;
